import { IntegrationChecklistStep } from './integration-checklist.model';

export const SECUREPAY_API_DOCS_URL = 'https://docs.getsecurepay.ai';

/** UI step number used for the activate sandbox action. */
export const ACTIVATE_SANDBOX_STEP = 0;

/** Canonical step list — always shown together; API updates merge into this. */
export const INTEGRATION_CHECKLIST_STEP_DEFINITIONS: Pick<
  IntegrationChecklistStep,
  'step' | 'name'
>[] = [
  { step: 1, name: 'API Reference Review' },
  { step: 2, name: 'Test Payment' },
  { step: 3, name: 'Webhook Configuration' },
  { step: 4, name: 'Integration Test Suite' },
  { step: 5, name: 'End-to-End Test' },
];

export interface TestPaymentLifecycleStage {
  id: string;
  label: string;
}

export const TEST_PAYMENT_LIFECYCLE_STAGES: TestPaymentLifecycleStage[] = [
  { id: 'initiated', label: 'Payment initiated' },
  { id: 'webhook', label: 'Webhook received' },
  { id: 'successful', label: 'Transaction marked SUCCESSFUL' },
  { id: 'settlement', label: 'Settlement queued' },
];

export interface IntegrationTestSuiteCaseDefinition {
  testKey: string;
  name: string;
  scenarioName: string;
  remediation: string;
}

export const INTEGRATION_TEST_SUITE_CASES: IntegrationTestSuiteCaseDefinition[] =
  [
    {
      testKey: 'successful_payment_webhook',
      name: 'Successful payment webhook',
      scenarioName: 'Successful Payment Webhook',
      remediation:
        'Verify your webhook endpoint returns HTTP 200 within 5 seconds and that your handler persists the event before responding.',
    },
    {
      testKey: 'duplicate_event_id',
      name: 'Duplicate event ID rejection',
      scenarioName: 'Duplicate Event ID Rejection',
      remediation:
        'Store processed event IDs and return 200 without re-processing when the same event ID is received again.',
    },
    {
      testKey: 'replay_attack',
      name: 'Replay attack rejection (timestamp > 5 min)',
      scenarioName: 'Replay Attack Rejection (Timestamp > 5 min)',
      remediation:
        'Reject webhooks whose timestamp is older than five minutes compared to server time.',
    },
    {
      testKey: 'invalid_hmac',
      name: 'Invalid HMAC signature rejection',
      scenarioName: 'Invalid HMAC Signature Rejection',
      remediation:
        'Validate the HMAC signature using your configuration secret before processing any webhook payload.',
    },
    {
      testKey: 'config_amount_deviation',
      name: 'Config amount deviation handling',
      scenarioName: 'Config Amount Deviation Handling',
      remediation:
        'Handle amount mismatch events per the API reference: log, alert, and do not treat the payment as successful without reconciliation.',
    },
    {
      testKey: 'config_id_not_found',
      name: 'Config ID not found handling',
      scenarioName: 'Config ID Not Found Handling',
      remediation:
        'Return an appropriate error response when the configuration ID in the webhook does not match a known merchant configuration.',
    },
  ];
